import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { getPreciseLocation } from '@/lib/geolocation';

const getSourceFromReferrer = (referrer: string): string => {
  if (!referrer) return 'direct';
  if (referrer.includes('facebook.com')) return 'facebook';
  if (referrer.includes('twitter.com') || referrer.includes('t.co')) return 'twitter';
  if (referrer.includes('instagram.com')) return 'instagram';
  if (referrer.includes('linkedin.com')) return 'linkedin';
  if (referrer.includes('google.com')) return 'google';
  if (referrer.includes('bing.com')) return 'bing';
  if (referrer.includes('youtube.com')) return 'youtube';
  return 'other';
};

export const useTrackActivity = () => {
  useEffect(() => {
    const trackVisit = async () => {
      const referrer = document.referrer;
      const source = getSourceFromReferrer(referrer);
      
      // Extract share_id from URL params
      const urlParams = new URLSearchParams(window.location.search);
      const shareId = urlParams.get('ref');
      
      // Detect platform
      const userAgent = navigator.userAgent;
      let platform = 'web';
      if (/android/i.test(userAgent)) platform = 'android';
      else if (/iPad|iPhone|iPod/.test(userAgent)) platform = 'ios';
      else if (/Windows/.test(userAgent)) platform = 'windows';
      else if (/Macintosh/.test(userAgent)) platform = 'mac';
      else if (/Linux/.test(userAgent)) platform = 'linux';
      
      const locationData = await getPreciseLocation();
      
      await supabase.from('link_tracking').insert({
        referrer: referrer || 'direct',
        source,
        landing_page: window.location.pathname,
        user_agent: navigator.userAgent,
        share_id: shareId,
        platform,
        city: locationData.city,
        country: locationData.country,
        region: locationData.region,
        latitude: locationData.latitude,
        longitude: locationData.longitude,
      });
    };

    trackVisit();
  }, []);

  const trackNumberGeneration = async (
    minValue: number,
    maxValue: number,
    count: number,
    generatedNumbers: number[],
    wasBackdoor: boolean = false,
    userEmail?: string
  ) => {
    await supabase.from('number_generations').insert({
      user_email: userEmail,
      min_value: minValue,
      max_value: maxValue,
      count,
      generated_numbers: generatedNumbers,
      was_backdoor: wasBackdoor,
      referrer: document.referrer || 'direct',
      user_agent: navigator.userAgent
    });
  };

  return { trackNumberGeneration };
};